import React, { useCallback, useState } from 'react';
import BiOption from '@wix/da-bi/pkg/Components/BiOption';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { isDropdownGroup, findSelectedItem } from '../helpers';
import { useDropdownItems } from '../hooks/useDropdownItems';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
const DUMMY_OPTION = {
    selected: true,
    disabled: true,
    hidden: true,
    value: 'null',
    label: ''
};
const NativeDropdown = ({ items, onSelect, onClick, className, name, biData, openBiData = biData, closeBiData = biData })=>{
    const { filteredItems } = useDropdownItems(items);
    const selectedItem = findSelectedItem(filteredItems);
    const [isOpen, setOpen] = useState(false);
    const logBiEvent = useBiLogger();
    const memoizedBiData = useDeepEqualMemo(isOpen ? closeBiData : openBiData);
    const onClickWithBi = useCallback((event)=>{
        memoizedBiData && logBiEvent(memoizedBiData);
        setOpen((open)=>!open);
        onClick && onClick(event);
    }, [
        memoizedBiData,
        logBiEvent,
        onClick
    ]);
    const renderOption = ({ value, label, hidden, disabled, biData: optionBiData })=>/*#__PURE__*/ React.createElement(BiOption, {
            key: value,
            hidden: hidden,
            value: value,
            disabled: disabled,
            biData: optionBiData,
            label: label
        }, label, ' ');
    const renderOptGroup = ({ label, disabled, items: groupItems })=>/*#__PURE__*/ React.createElement("optgroup", {
            key: label,
            label: label,
            disabled: disabled
        }, groupItems.map(renderOption));
    return /*#__PURE__*/ React.createElement("select", {
        onChange: (e)=>onSelect(e.target.value, e),
        onClick: onClickWithBi,
        className: className,
        name: name,
        value: selectedItem ? selectedItem.value : DUMMY_OPTION.value
    }, !selectedItem && renderOption(DUMMY_OPTION), filteredItems.map((item)=>isDropdownGroup(item) ? renderOptGroup(item) : renderOption(item)));
};
NativeDropdown.displayName = 'NativeDropdown';
export default NativeDropdown;
